
<div class="alert d-flex" role="alert" [ngClass]="status === 'success' ? 'success': 'error'">
    <div class="icon d-flex align-items-center justify-content-center">
        <mat-icon [ngClass]="status === 'success' ? 'sif sif-checkmark': 'sif sif-warning'"></mat-icon>
    </div>
    <div class="message w-100">{{message}}</div>
</div>